if (!window.customElements.get('push-image')) {
  class PushImage extends HTMLElement {
    connectedCallback() {
      this.blocks = this.querySelectorAll('[js-push-image-block]');
      this.dashes = this.querySelectorAll('[js-push-image-dash]');
      this.images = this.querySelectorAll('[data-image-block-id]');
      this.isMobile = window.matchMedia('(max-width: 999px)').matches;

      this.blocks.forEach((block) => {
        block.addEventListener('click', (event) =>
          this.onBlockClick(event, block),
        );

        if (!this.isMobile) {
          block.addEventListener('mouseenter', () =>
            this.showImage(block.dataset.blockId),
          );
        }
      });

      if (!this.isMobile) {
        this.querySelector('.push-image__blocks')?.addEventListener(
          'mouseleave',
          () => {
            this.showImage(this.images[0]?.dataset.imageBlockId);
          },
        );
      }

      this.dashes.forEach((dash) => {
        dash.addEventListener('click', () =>
          this.setActiveBlock(dash.dataset.blockId),
        );
      });

      if (this.isMobile && this.blocks.length > 1) {
        this.setupSwipe();
      }

      this.syncDashes();
    }

    setupSwipe() {
      let touchStartX = 0;
      let touchStartY = 0;
      const threshold = 50;

      this.addEventListener(
        'touchstart',
        (event) => {
          touchStartX = event.touches[0].clientX;
          touchStartY = event.touches[0].clientY;
        },
        { passive: true },
      );

      this.addEventListener(
        'touchmove',
        (event) => {
          const deltaX = event.touches[0].clientX - touchStartX;
          const deltaY = event.touches[0].clientY - touchStartY;

          if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > 10) {
            event.preventDefault();
          }
        },
        { passive: false },
      );

      this.addEventListener(
        'touchend',
        (event) => {
          const deltaX = event.changedTouches[0].clientX - touchStartX;
          const deltaY = event.changedTouches[0].clientY - touchStartY;

          if (
            Math.abs(deltaX) < threshold ||
            Math.abs(deltaX) < Math.abs(deltaY)
          ) {
            return;
          }

          this.goToAdjacentBlock(deltaX < 0 ? 1 : -1);
        },
        { passive: true },
      );
    }

    goToAdjacentBlock(direction) {
      const blocks = Array.from(this.blocks);
      const activeIndex = blocks.findIndex((block) =>
        block.classList.contains('is-active'),
      );
      const currentIndex = activeIndex === -1 ? 0 : activeIndex;
      const nextIndex =
        (currentIndex + direction + blocks.length) % blocks.length;

      this.setActiveBlock(blocks[nextIndex].dataset.blockId);
    }

    onBlockClick(event, block) {
      if (!this.isMobile) return;

      if (!block.classList.contains('is-active')) {
        event.preventDefault();
        this.setActiveBlock(block.dataset.blockId);
      }
    }

    setActiveBlock(blockId) {
      this.blocks.forEach((block) => {
        block.classList.toggle('is-active', block.dataset.blockId === blockId);
      });

      this.showImage(blockId);
      this.syncDashes();
    }

    showImage(blockId) {
      this.images.forEach((image) => {
        image.classList.toggle(
          'is-visible',
          image.dataset.imageBlockId === blockId,
        );
      });
    }

    syncDashes() {
      const activeBlock =
        this.querySelector('[js-push-image-block].is-active') || this.blocks[0];

      this.dashes.forEach((dash) => {
        const isActive = dash.dataset.blockId === activeBlock?.dataset.blockId;
        dash.classList.toggle('is-active', isActive);
        dash.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
    }
  }

  window.customElements.define('push-image', PushImage);
}
